import React from 'react';
import { NextIcon } from './NextIcon';

export const PrevIcon = () => {
  return <NextIcon style={{ transform: 'rotate(180deg)' }} />
}
